export type ModalState = {
  show: boolean;
  component?: React.FC;
  inputData?: any;
  onSubmit?: (outputData?: any) => void;
};

export const initialModalState: ModalState = {
  show: false,
};
